import { z } from 'zod/v4';

export const createCommentSchema = z.object({
  content: z.string({ message: 'Комментарий обязателен' })
    .min(1, 'Комментарий не может быть пустым')
    .max(2000, 'Комментарий слишком длинный (максимум 2000 символов)'),
});

export const updateCommentSchema = z.object({
  content: z.string({ message: 'Комментарий обязателен' })
    .min(1, 'Комментарий не может быть пустым')
    .max(2000, 'Комментарий слишком длинный (максимум 2000 символов)'),
});

export type CreateCommentInput = z.infer<typeof createCommentSchema>;
export type UpdateCommentInput = z.infer<typeof updateCommentSchema>;
